import React, { useEffect, useState } from 'react';
import './DashboardLoading.css';

const dashboardLogo = require('./assets/superpenguin-logo.webp');

/** Show one neutral bootstrap state while identity and provider access are restored. */
export const DashboardLoading: React.FC = () => {
    const [isTakingLonger, setIsTakingLonger] = useState(false);

    useEffect(() => {
        const timer = window.setTimeout(() => setIsTakingLonger(true), 12_000);
        return () => window.clearTimeout(timer);
    }, []);

    return (
        <main className='dashboard-loading' aria-busy='true'>
            <section className='dashboard-loading__card' role='status' aria-live='polite'>
                <img src={dashboardLogo} alt='SuperPenguin' className='dashboard-loading__logo' />
                <span className='dashboard-loading__spinner' aria-hidden='true' />
                <h1>Preparing your dashboard</h1>
                <p>
                    {isTakingLonger
                        ? 'This is taking longer than usual. Your account is still being checked safely.'
                        : 'Loading your account, organisation and permissions…'}
                </p>
                {isTakingLonger && (
                    <button type='button' onClick={() => window.location.reload()}>Try again</button>
                )}
            </section>
        </main>
    );
};
